import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthToken } from '@/services/api';

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated
    const authToken = getAuthToken();
    
    if (authToken) {
      // If authenticated, redirect to dashboard
      navigate('/dashboard', { replace: true });
    } else {
      // If not authenticated, redirect to login
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-gradient-to-br from-[#50b3e1] to-[#0997a4] rounded-2xl flex items-center justify-center mx-auto mb-4 animate-pulse">
          <i className="ri-hospital-line text-white text-3xl"></i>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">HIC Stock Management</h1>
        <p className="text-gray-600 text-sm">Loading...</p>
      </div>
    </div>
  );
}
